import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { ConfigurationDocumentKind, GapFillingMethod } from '@skylab-shared/dataModel';

export interface NumberingItem {
    readonly id: number;
    readonly active: boolean;
    readonly default: boolean;
    readonly name: string;
    readonly kinds: (ConfigurationDocumentKind)[];
    readonly format: string;
    readonly startingNumber: number;
    readonly used: boolean;
    readonly gapFillingMethod: GapFillingMethod;
    readonly manual: boolean;
}

interface NumberingInternalItem {
    readonly startingNumber: number;
    readonly used: boolean;
    readonly default: boolean;
    readonly manual: boolean;
    readonly version: string;
    readonly name: string;
    readonly format: string;
    readonly id: number;
    readonly kinds: (ConfigurationDocumentKind)[];
    readonly gapFilling: GapFillingMethod;
    readonly active: boolean;
}

export class NumberingQuery extends Query<NumberingItem[]> { }

export class NumberingQueryHandlerBase implements QueryHandler<NumberingQuery, NumberingItem[]> {
    private static Url = TaggedUrl.join('system/numberings', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: NumberingQuery): Promise<NumberingItem[]> {
        const { data } = await this.http.get<{ items: NumberingInternalItem[]; }>(NumberingQueryHandlerBase.Url);
        return data.items.map(i => ({
            id: i.id,
            active: i.active,
            default: i.default,
            name: i.name,
            kinds: i.kinds,
            format: i.format,
            startingNumber: i.startingNumber,
            used: i.used,
            gapFillingMethod: i.gapFilling,
            manual: i.manual
        }));
    }
}
